module.exports = __webpack_public_path__ + "static/media/6_Jens_Winter_Zertifikate.8260c9c1.jpg";